var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrushTool(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brush-tool_svg__a",
    x1: 10.5,
    y1: 10,
    x2: 29,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    stopColor: "var(--text-color-hover)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4,
    stopColor: "var(--text-color-hover)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.5c-5.5-6-17 10-19 12s1 5 3 3S17.944 6.972 20 8c3 1.5-12 12.5-7 17s11.226-7.683 13-6.5c1.774 1.183-5.5 5.5-2 8 2.882 2.059 5.5-2.5 5-3s-2.75 2.75-3.75 1.75c-1.5-1.5 6.25-5.75 2.25-8.75S17 25 15 23s12.778-12.287 8-17.5z",
    fill: "url(#brush-tool_svg__a)",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushTool);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIxMC40OTk5IiB5MT0iMTAiIHgyPSIyOC45OTk5IiB5Mj0iMjciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1vcGFjaXR5PSIwLjgiIHN0b3AtY29sb3I9InZhcigtLXRleHQtY29sb3ItaG92ZXIpIiAvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3Atb3BhY2l0eT0iMC40IiBzdG9wLWNvbG9yPSJ2YXIoLS10ZXh0LWNvbG9yLWhvdmVyKSIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxnIG9wYWNpdHk9IjAuNSI+CiAgICA8cGF0aAogICAgICBkPSJNMjIuOTk5OSA1LjVDMTcuNDk5OSAtMC41IDUuOTk5ODkgMTUuNSAzLjk5OTg5IDE3LjVDMS45OTk5IDE5LjUgNC45OTk5IDIyLjUgNi45OTk5IDIwLjVDOC45OTk4OSAxOC41IDE3Ljk0NDQgNi45NzIyNiAxOS45OTk5IDhDMjIuOTk5OSA5LjUgNy45OTk4OSAyMC41IDEyLjk5OTkgMjVDMTcuOTk5OSAyOS41IDI0LjIyNTkgMTcuMzE3MyAyNS45OTk5IDE4LjVDMjcuNzczOSAxOS42ODI3IDIwLjQ5OTkgMjQgMjMuOTk5OSAyNi41QzI2Ljg4MjEgMjguNTU4NyAyOS40OTk5IDI0IDI4Ljk5OTkgMjMuNUMyOC40OTk5IDIzIDI2LjI0OTkgMjYuMjUgMjUuMjQ5OSAyNS4yNUMyMy43NDk5IDIzLjc1IDMxLjQ5OTkgMTkuNSAyNy40OTk5IDE2LjVDMjMuNDk5OSAxMy41IDE2Ljk5OTkgMjUgMTQuOTk5OSAyM0MxMi45OTk5IDIxIDI3Ljc3OCAxMC43MTI1IDIyLjk5OTkgNS41WiIKICAgICAgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIgLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };